import { useEffect, useState } from 'react'

import { saveAs } from 'file-saver'

import { UTCFormatDate } from 'components/ui/transaction-history/components/transaction/utils'

import { useTranslation } from 'utils/use-translation'

import { useHeader } from '../../../utils/use-header'

import { getUserReferrals } from '../../../store/fetchers/users'

import { IUserReferrals, IUserReferralsLoan } from '../../../store/fetchers/users/types'

import { useAppSelector } from '../../../store/hooks'

import { selectedUser } from '../../../store/reducers/users'

import CalculateProfitReferral from './calculate-profit'

import HowToStartEarning from './how-to-start-earning'
import ReferralCode from './referral-code'
import ReferralProgramRules from './referral-program-rules'
import styles from './styles.module.scss'
import ReferralRewards from './referral-rewards'
import DownloadIcon from './referral-rewards/icons/download-icon.svg'

const headerCSVRows = ['Created At', 'Type', 'Coin', 'Profit', 'Id', 'Status'].join(',') + '\r\n'

const Referral = () => {
  const { t } = useTranslation()

  const [userReferrals, setUserReferrals] = useState<IUserReferrals>(null)
  const user = useAppSelector(selectedUser)

  const [list, setList] = useState<IUserReferralsLoan[]>([])


  const getUserReferralsData = async () => {
    if (user) {
      const data = await getUserReferrals()
      setList(data.loans)
      setUserReferrals(data)
    }
  }

  useEffect(() => {
    getUserReferralsData()
  }, [user])

  const saveCSV = () => {
    const rows = []

    list.forEach((data) => {
      const { created_at, code, network, profit, id, status } = data
      const coin = code.toLowerCase() + ' ' + network.toLowerCase()
      const res = [UTCFormatDate(created_at), 'Reward', coin, profit, id, status].join(',') + '\r\n'

      rows.push(res)
    })
    saveAs(new Blob([headerCSVRows, ...rows], { type: 'text/csv;charset=utf-8' }), `CoinRabbit_Loan_1_history.csv`)
  }

  const head = useHeader(
    t('referral_rewards'),
    'Get your referral code, invite your friends to sign up, swap and borrow crypto. Get up to 0.2% from each loan while it’s active',
  )
  return (
    <div className={styles.wrapper}>
      {head}
      <div className={styles.referral}>
        <h1 className={styles.title}>{t('referral_rewards')}</h1>
        <h2 className={styles.subtitle}>
          {t('invite_friends_sign_up')}&nbsp;
          {t('get_up_to_02%')}
        </h2>

        <section className={styles.section}>
          <ReferralCode userReferrals={userReferrals} getUserReferralsData={getUserReferralsData} />
        </section>

        <section className={styles.section}>
          <div className={styles.header}>
            <h3>{t('calculate_profit')}</h3>
          </div>

          <CalculateProfitReferral />
        </section>

        <section className={styles.section}>
          <div className={styles.header}>
            <h3>{t('how_to_earn')}</h3>
          </div>

          <HowToStartEarning />
        </section>

        <section className={styles.section}>
          <div className={styles.header}>
            <h3>{t('referral_rewards')}</h3>

            <div className={styles.right}>
              <button className={styles.download} onClick={saveCSV}>
                <img src={DownloadIcon} alt="download icon" />
                <p>{t('download_csv')}</p>
              </button>
            </div>
          </div>

          <ReferralRewards saveCSV={saveCSV} list={list} />
        </section>

        <section className={styles.section}>
          <div className={styles.header}>
            <h3>{t('referral_program_rules')}</h3>
          </div>

          <ReferralProgramRules />
        </section>
      </div>
    </div>
  )
}

export default Referral
